module.exports = __webpack_public_path__ + "img/上海交通.ada54d79.png";